import React from "react";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import { useTranslation } from "lib/i18n/use-translation";
import { Button } from "components/ui";

import styles from "./assessment-modal.module.scss";

interface ExitAssessmentModalProps {
  onNo?: () => void;
  onYes?: () => void;
  onOkay?: () => void;
  title?: string;
  subtitle?: string;
}

function AssessmentModal({
  onNo,
  onYes,
  onOkay,
  title,
  subtitle,
}: ExitAssessmentModalProps) {
  const { t } = useTranslation(["common"]);

  return (
    <Modal
      isOpen={true}
      style={{ width: "auto", maxWidth: "400px" }}
      className={styles["modal"]}
      contentClassName={styles["modal-content"]}
    >
      <ModalBody className={styles["body"]}>
        <h1>{title}</h1>
        <p> {subtitle}</p>
      </ModalBody>
      <ModalFooter className={styles["footer"]}>
        {onNo && (
          <Button variant="enclosed-secondary" onClick={onNo}>
            {t("common:action.no")}
          </Button>
        )}
        {onYes && (
          <Button variant="enclosed-primary" onClick={onYes}>
            {t("common:action.yes")}
          </Button>
        )}
        {onOkay && (
          <Button variant="enclosed-primary" onClick={onOkay}>
            {t("common:action.okay")}
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
}

export default AssessmentModal;
